var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-contain"},[_c('div',{staticClass:"go-public",attrs:{"id":"goPublic"},on:{"click":_vm.goPublic}},[_vm._v(" 河南郑州航空港人才 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }